export const USER_LOGIN = 'USER_LOGIN'
export const USER_CLEAR = 'USER_CLEAR'

export const OPEN_SNACKBAR = 'OPEN_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'

export const SET_REGIONS = 'SET_REGIONS'
export const SET_USERS_DS = 'SET_USERS_DS'

export const OPEN_POPUP = 'OPEN_POPUP'
export const CLEAR_POPUP = 'CLEAR_POPUP'
export const CLOSE_POPUP = 'CLOSE_POPUPS'